import React from "react";
import Hero from "../components/_sections/Landing/Hero";
import FeaturesSection from "../components/_sections/Landing/FeaturesSection";
import AcademySection from "../components/_sections/Landing/AcademySection";
import CTA from "../components/_sections/Landing/CTA";
import LandingFooter from "../components/_sections/Landing/Footer";
import EventSection from "../components/_sections/Landing/EventSection";
import Testimonials from "../components/_sections/Landing/Testimonials";
import Header from "../components/_sections/Landing/Header";
import Sponsor from "../components/_sections/Landing/Sponsor";
import EventGallery from "../components/_sections/Landing/EventGallery";
import { CssBaseline, CssVarsProvider, useColorScheme } from "@mui/joy";

export default function LandingPage() {
  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Content />
    </CssVarsProvider>
  );
}

function Content() {
  const { mode } = useColorScheme();
  const dark = mode === "dark";
  return (
    <div className={`${mode === 'light' ? 'bg-white' : 'bg-gray-900'}`}>
      <Header dark={dark} />
      <Hero dark={dark} />
      <FeaturesSection dark={dark} />
      <AcademySection dark={dark} />
      <EventSection dark={dark} />
      <Sponsor  dark={dark} />
      <Testimonials dark={dark} />
      <EventGallery dark={dark} />
      <CTA dark={dark} />
      <LandingFooter />
    </div>
  );
}